module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (256).b3ab3d7b.jpg";